import { axiosInstance } from 'plugins/axios'
import { LocalStorage } from 'quasar'
import api from '../../components/util/api'

const API = process.env.API
const API_AUTENTICACAO = API + '/oauth/token'
const API_USUARIO_ACESSO = API + '/usuario/acessos'
const LOCALSTORAGE_ACCESS_TOKEN = 'access_token'

export function autenticar (state, usuario) {
  var body = new URLSearchParams()
  body.append('username', usuario.desLogin)
  body.append('password', usuario.senha)
  body.append('grant_type', 'password')

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Authorization': 'Basic Y2FkLXVuaWNvLWFwaS1jbGllbnRlOkcwdjNybjRAMjAxOQ==' // Basic Auth: cad-unico-api-cliente / G0v3rn4@2019
    }
  }
  return axiosInstance.post(API_AUTENTICACAO, body, config).then((response) => {
    let token = response.data.access_token
    LocalStorage.set(LOCALSTORAGE_ACCESS_TOKEN, token)

    axiosInstance.defaults.headers.common['Authorization'] = 'Bearer ' + token
    axiosInstance.get(API_USUARIO_ACESSO).then(resposta => {
      let aplicacao = resposta.data.aplicacoes.filter(a => a.gidAplicacao === api.APLICACAO_GID)[0]
      let cliente = resposta.data.cliente
      let usuario = {
        codUsuario: response.data.codUsuario,
        desLogin: response.data.desLogin,
        nomUsuario: response.data.nomUsuario,
        accessToken: token,
        acesso: resposta.data,
        permissoes: resposta.data.aplicacoes !== null && resposta.data.aplicacoes !== undefined ? resposta.data.aplicacoes[0].perfis[0].permissoes : '',
        aplicacao: aplicacao,
        cliente: cliente
      }
      state.commit('setUsuario', usuario)
      // state.commit('setUsuarioAcesso', )
    })
  })
}

export function sair (state) {
  localStorage.clear()
  state.usuario = null
}
